import { BaseValuationRow } from './types';
import { formatSummaryNumber } from '@dealstack/frontend/app/pages/Valuations/components/table/utils/formatting';

/**
 * @deprecated This class is deprecated and will be removed. Please use the columnBuilder instead.
 */
export abstract class BaseTransformer<TData, TRow extends BaseValuationRow = BaseValuationRow> {
	protected static formatNumber(value: number): string {
		return formatSummaryNumber(value);
	}

	abstract toTableData(data?: TData): TRow[];
}
